import { documentFor, } from '../outline';
export function defineTemplate(input) {
    const definition = input.page === undefined
        ? input
        : {
            ...input,
            themeId: input.themeId ?? input.page.themeId,
            surface: input.surface ?? input.page.surface,
            ink: input.ink ?? input.page.ink,
        };
    return {
        id: definition.id,
        name: definition.name,
        description: definition.description,
        category: definition.category,
        document: documentFor({
            templateId: definition.id,
            root: definition.root,
            ...(definition.layoutId === undefined ? {} : { layoutId: definition.layoutId }),
            ...(definition.themeId === undefined ? {} : { themeId: definition.themeId }),
            ...(definition.shape === undefined ? {} : { shape: definition.shape }),
            ...(definition.palette === undefined ? {} : { palette: definition.palette }),
            ...(definition.branchShape === undefined ? {} : { branchShape: definition.branchShape }),
            ...(definition.rootShape === undefined ? {} : { rootShape: definition.rootShape }),
            ...(definition.look === undefined ? {} : { look: definition.look }),
            ...(definition.rootStyle === undefined ? {} : { rootStyle: definition.rootStyle }),
            ...(definition.surface === undefined ? {} : { surface: definition.surface }),
            ...(definition.ink === undefined ? {} : { ink: definition.ink }),
            ...(definition.links === undefined ? {} : { links: definition.links }),
        }),
        ...(definition.keywords === undefined ? {} : { keywords: definition.keywords }),
    };
}
//# sourceMappingURL=define.js.map